import {objLookup} from "../../util/common";
const user_currency_code = objLookup(window.loggedInUser, 'region.currency_code') || 'NZD';
const user_currency_sign = objLookup(window.loggedInUser, 'region.currency_sign') || '$';

const state = {
    user_currency_code,
    user_currency_sign,
};

// getters
const getters = {
};

// actions
const actions = {
};

// mutations
const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/currency.js